import { render, staticRenderFns } from "./NewDDocumentEditor.vue?vue&type=template&id=63959f2b&"
import script from "./NewDDocumentEditor.vue?vue&type=script&lang=js&"
export * from "./NewDDocumentEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports